export const avatarLogoBcp: React.FC = () => {
	return (
		<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
				fill="white"
			/>
			<path
				d="M21.2788 25.9849L16.6263 14.9531C15.178 11.563 13.1401 10.1765 11.522 9.78502C10.8002 9.53264 8.70703 9.7035 8.70703 9.7035C8.70703 9.7035 10.2846 9.78502 11.1505 10.448C12.3622 11.2483 13.116 13.1207 12.7802 15.656L11.3055 26.6848C11.108 28.0359 10.7146 30.263 10.7146 30.263H12.8319C12.8319 30.263 12.9642 28.5614 13.1615 27.0354L14.5731 16.279L19.2754 27.5614C19.8689 28.9621 20.2153 29.6378 21.4527 30.5882L26.9962 16.254L28.4069 28.3117C28.4875 29.1636 28.5492 30.2634 28.5492 30.2634H31.2953C31.2953 30.2634 31.0549 28.812 30.9058 27.636L29.2724 15.3532C29.2226 14.7779 29.1569 13.8024 29.1569 13.8024H25.758V13.8278C25.758 14.3527 25.5845 14.8529 25.3871 15.3785L21.2788 25.9849Z"
				fill="#D1005D"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20 38.3333C30.1252 38.3333 38.3333 30.1252 38.3333 20C38.3333 9.87478 30.1252 1.66667 20 1.66667C9.87478 1.66667 1.66667 9.87478 1.66667 20C1.66667 30.1252 9.87478 38.3333 20 38.3333ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
				fill="#EFF0F5"
			/>
		</svg>
	);
};
